import { PATH_GAMES } from '@/routes/paths'
import { Game } from '@/types'
import { getThumbnailUrl } from '@/utils/game'

export const originals: Game[] = [
  {
    id: 'dice',
    name: 'Dice',
    path: PATH_GAMES.dice,
    thumbnail: {
      url: getThumbnailUrl('dice'),
      blurHash: 'UTD26Js=0[X..EoeT1X55]oy-MRjAKWCxabb',
    },
    rtp: 99,
    isOriginal: true,
  },
  {
    id: 'keno',
    name: 'Keno',
    path: PATH_GAMES.keno,
    thumbnail: {
      url: getThumbnailUrl('keno'),
      blurHash: 'UCKi~7-C*y#X0]N@P9O9|3WUWZsp=|n*:swh',
    },
    rtp: 99,
    isOriginal: true,
  },
  {
    id: 'plinko',
    name: 'Plinko',
    path: PATH_GAMES.plinko,
    thumbnail: {
      url: getThumbnailUrl('plinko'),
      blurHash: 'U8H*=b$q08wm9Wn#pENtE?sRRjNy?Kj[R7sC',
    },
    rtp: 99,
    isOriginal: true,
  },
  {
    id: 'limbo',
    name: 'Limbo',
    path: PATH_GAMES.limbo,
    thumbnail: {
      url: getThumbnailUrl('limbo'),
      blurHash: 'USS{c8%KmQ%M*GjFn3kWrCivaJj[$wi{XSj=',
    },
    rtp: 99,
    isOriginal: true,
  },
  {
    id: 'mines',
    name: 'Mines',
    path: PATH_GAMES.mines,
    thumbnail: {
      url: getThumbnailUrl('mines'),
      blurHash: 'U9G~WF-Y01Ie1CfgG6NX1oR+]oxF3DS0|6xJ',
    },
    rtp: 99,
    isOriginal: true,
  },
  {
    id: 'tower',
    name: 'Tower',
    path: PATH_GAMES.tower,
    thumbnail: {
      url: getThumbnailUrl('tower'),
      blurHash: 'U8CHAhtQ00S_._n+I;WB0Kj[}]jGTwj[#qn+',
    },
    rtp: 99,
    isOriginal: true,
  },
  {
    id: 'roulette',
    name: 'Roulette',
    path: PATH_GAMES.roulette,
    thumbnail: {
      url: getThumbnailUrl('roulette'),
      blurHash: 'UFKGq4xG:k#:0{R*xuW;kEoL62WV}]oMEea|',
    },
    rtp: 99,
    isOriginal: true,
  },
  {
    id: 'hilo',
    name: 'Hilo',
    path: PATH_GAMES.hilo,
    thumbnail: {
      url: getThumbnailUrl('hilo'),
      blurHash: 'UhGwG=o}0qnp?*R%NLxa5=NG$xxtEmX7s.nQ',
    },
    rtp: 99,
    isOriginal: true,
  },
  {
    id: 'coin-flip',
    name: 'Coin Flip',
    path: PATH_GAMES.coinFlip,
    thumbnail: {
      url: getThumbnailUrl('coin'),
      blurHash: 'UGN@WG$%03wK4ENbEUSg8.Rm~fs.RsWX^ss,',
    },
    rtp: 99,
    isOriginal: true,
  },
  {
    id: 'wheel',
    name: 'Wheel',
    path: PATH_GAMES.wheel,
    thumbnail: {
      url: getThumbnailUrl('wheel'),
      blurHash: 'UnOcpDs.|?$MF=WV%1kB^KoKJRfj-nj[aejZ',
    },
    rtp: 99,
    isOriginal: true,
  },
  {
    id: 'blackjack',
    name: 'Blackjack',
    path: PATH_GAMES.blackjack,
    thumbnail: {
      url: getThumbnailUrl('blackjack'),
      blurHash: 'U9D_D}JP00XN00nO-=a{0J-=}]oz=}M_xuaL',
    },
    rtp: 99,
    isOriginal: true,
  },
]
